import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'
import type { FolderBrowseMode } from '@/lib/browse-folder-focus'

const SEGMENTS: { id: FolderBrowseMode; label: string }[] = [
  { id: 'default', label: 'Auto' },
  { id: 'always', label: 'Show' },
  { id: 'hidden', label: 'Hide' },
]

type BrowseFolderVisibilityPillProps = {
  mode: FolderBrowseMode
  onModeChange: (mode: FolderBrowseMode) => void
  /** When true, use compact padding for context menu embedding. */
  embedded?: boolean
}

export function BrowseFolderVisibilityPill({
  mode,
  onModeChange,
  embedded = true,
}: BrowseFolderVisibilityPillProps) {
  return (
    <div
      className={cn(embedded ? 'px-2 py-1.5 space-y-1' : 'space-y-1.5')}
      onPointerDown={(e) => e.preventDefault()}
    >
      <Label className="text-[11px] font-medium text-muted-foreground leading-none">
        Browse visibility
      </Label>
      <div
        role="radiogroup"
        aria-label="Browse visibility"
        className="flex w-full rounded-md border border-border bg-muted/50 p-0.5"
      >
        {SEGMENTS.map((seg) => (
          <button
            key={seg.id}
            type="button"
            role="radio"
            aria-checked={mode === seg.id}
            className={cn(
              'flex-1 rounded-[3px] px-0.5 py-1 text-[11px] font-medium leading-none transition-colors',
              mode === seg.id
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )}
            onPointerDown={(e) => e.preventDefault()}
            onClick={() => {
              if (seg.id !== mode) onModeChange(seg.id)
            }}
          >
            {seg.label}
          </button>
        ))}
      </div>
    </div>
  )
}
